<template lang="pug">
div
  screen-title(title="online_booking.cancelation_policy_title")
  .box
    
    b-field(:label="$t('online_booking.cancelation_policy_by_customer')")
      b-switch(v-model="deposit.cancelByCustomer") {{deposit.cancelByCustomer ? $t('misc.allow') : $t('misc.disallow')}}
    b-field(:label="$t('online_booking.cancelation_policy')" :message="$t('online_booking.cancelation_policy_desc')")
      b-select(v-model="deposit.cancelationPolicy")
        option(:value="-1" ) {{$t("cancelation_policy.free_cancellation")}}
        option(:value="2" ) {{$t("cancelation_policy.two_hours")}}
        option(:value="4" ) {{$t("cancelation_policy.four_hours")}}
        option(:value="6" ) {{$t("cancelation_policy.six_hours")}}
        option(:value="12") {{$t("cancelation_policy.twelve_hours")}}
        option(:value="24") {{$t("cancelation_policy.one_day")}}
        option(:value="48") {{$t("cancelation_policy.two_days")}}
        option(:value="72") {{$t("cancelation_policy.three_days")}}
        option(:value="168")  {{$t("cancelation_policy.one_week")}}
        option(:value="null")  {{$t("cancelation_policy.no_refund")}}
    
    label.label(v-t="'online_booking.cancelation_policy_custom_text'")
    LocalizedEditor(v-model="deposit.policyText" type="textarea" :placeholder="$t('online_booking.policy_text_placeholder')")
  
  
  .buttons.mt-4
    action-button(title="actions.save" @click="submit" :loading="submitting" :permission="PERMISSIONS.core.COMPANY_SETTINGS_EDIT" scope)
</template>

<script>
import {mapState} from 'vuex'
import DEPOSIT_GROUP from '../../../constants/depositGroup'
import LocalizedEditor from '../shared/LocalizedEditor'
import PERMISSIONS from '../../../constants/permissions'
export default {
  name: 'OnlineBookingSettings',
  components: {
    LocalizedEditor
  },
  data() {
    return {
      submitting: false,
      PERMISSIONS,
      deposit: {
        active: false,
        defaultRatio: DEPOSIT_GROUP.FULL,
        cancelationPolicy: 24,
        policyText: {},
        cancelByCustomer: false
      }
    }
  },
  computed: {
    ...mapState('company', ['company']),
    policyTextPlaceholder() {
      let hours = this.deposit.cancelationPolicy
      if (!hours) {
        return this.$t('online_booking.policy_text.message')
      } else if (hours > 72) {
        return this.$t('online_booking.policy_text.message_with_days_refund', {hours, days: hours / 24})
      } else if (hours === -1) {
        return this.$t('online_booking.policy_text.message_with_free_cancellation')
      }
      return this.$t('online_booking.policy_text.message_with_hours_refund', {hours, days: hours / 24})
    }
  },
  created() {
    this.deposit = (this.company.deposit && Object.assign({}, this.company.deposit)) || this.deposit
    this.deposit.policyText = this.deposit.policyText || {}
  },
  methods: {
    async submit() {
      if (this.submitting) return
      this.submitting = true
      const valid = await this.$validator.validateAll()
      if (!valid) {
        this.submitting = false
        return
      }

      const data = {
        deposit: this.deposit
      }
      try {
        await this.$store.dispatch('company/update', data)
        this.$buefy.toast.open({message: this.$t('status.save_success'), type: 'is-success', queue: false})
        this.$emit('saved')
      } catch (error) {
        this.$handleAPIError(error)
      }
      this.submitting = false
    }
  }
}
</script>
